<!-- <app-page-header class="text-primary" Heading="Services">
  <button class="btn btn-primary btn-sm" (click)="openAlertServiceFormModal()">Add Services</button>
</app-page-header>


<div class="card mb-1">
  <div class="card-body px-1 py-0">
    <div class="d-flex align-items-end gap-3 filter-row w-100" id="filterContainer">
      <app-pagination [EnablePageSize]="true" (pageSizeChanged)="handlePageSizeChange($event)" [rowData]="serviceList">
      </app-pagination> -->

      <!-- Push this entire group to the right -->
      <!-- <div class="d-flex align-items-end gap-2 ms-auto pb-1">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" *ngFor="let tab of tabs" [ngbTooltip]="tab.tabName">
            <a #tabLink class="nav-link" [ngClass]="this.selectedTab == tab.tabName ? 'active' : ''"
              [attr.id]="tab.tabName+'-tab'" data-bs-toggle="tab" [attr.data-bs-target]="'#' + tab.tabName"
              type="button" role="tab" [attr.aria-controls]="tab.tabName"
              [attr.aria-selected]="this.selectedTab === tab.tabName" (click)="onTabSelect(tab.tabName)">
              <i class="{{tab.tabIcon}}"></i>
            </a>
          </li>
        </ul> -->
        <!-- Search Input -->
        <!-- <div class="d-flex align-items-end">
          <input type="search" id="usearch" class="form-control form-control-sm" placeholder="Search"
            (keyup.enter)="loadData()" [(ngModel)]="searchText" />
        </div> -->

        <!-- Load Button -->
        <!-- <div class="d-flex align-items-end">
          <button class="btn btn-primary btn-sm" (click)="loadData()" [disabled]="isLoading">Load Data</button>
        </div>

      </div>
    </div>
  </div>
</div> -->

<div class="d-flex justify-content-between align-items-center w-100">

    <div class="d-flex align-items-center gap-4">
        <app-page-header class="text-primary fw-bold" Heading="Services">
        </app-page-header>

        <app-pagination 
            [EnablePageSize]="true" 
            (pageSizeChanged)="handlePageSizeChange($event)" 
            [rowData]="serviceList">
        </app-pagination>
    </div>

    <div class="d-flex align-items-center gap-2">
        
        <ul class="nav nav-pills me-2" id="myTab" role="tablist">
            <li class="nav-item" *ngFor="let tab of tabs" [ngbTooltip]="tab.tabName">
                <a class="nav-link py-1 px-2" 
                   [ngClass]="selectedTab == tab.tabName ? 'active' : 'text-secondary'"
                   style="cursor: pointer;"
                   (click)="onTabSelect(tab.tabName)">
                    <i class="{{tab.tabIcon}}"></i>
                </a>
            </li>
        </ul>

        <input type="search" id="usearch" class="form-control form-control-sm" 
               style="width: 200px;"
               placeholder="Search..."
               (keyup.enter)="loadData()" 
               [(ngModel)]="searchText" />

        <button class="btn btn-sm btn-primary" 
                (click)="loadData()" 
                [disabled]="isLoading">
            Load
        </button>

        <button class="btn btn-sm btn-primary shadow-sm" (click)="openAlertServiceFormModal()" [disabled]="isLoading">
             Add Services
        </button>
    </div>

</div>





<div class="tab-content" id="myTabContent">
  <div *ngFor="let tab of tabs" class="tab-pane fade" [ngClass]="{'show active': tab.tabName === this.selectedTab}"
    [attr.id]="tab.tabName" role="tabpanel" [attr.aria-labelledby]="tab.tabName + '-tab'">

    <ng-container [ngSwitch]="tab.tabName">
      <div *ngSwitchCase="'Tabular'">

        <app-color-table [columns]="[
                                      {colName:'Name',colData:'title',enableRouting: true , routing :{route:'/notification/services',id:'serviceId'}},            
                                      {colName:'Status', colData: 'statusText'},    
                                      {colName:'Type', colData: 'alertType'},    
                                      {colName:'Last Run Time',colData:'lastExecutedOn',isDate:true},
                                      {colName:'Next Run Time',colData:'nextExecutionTime',isDate:true},
                                      {colName:'Created On',colData:'createdOn',isDate:true},
                                    ]" [tableData]="serviceList" [enableActionColumn]="true"
          [actionColumnLabel]="'Action'" [toggleStatus]="true" [actionOptions]="[
            {actionName:'View',actionIcon:'fa-solid fa-eye'},
            {actionName:'Edit',actionIcon:'fa fa-edit'},
            {actionName:'Add Variable',actionIcon:'fa-regular fa-square-plus'},
            {actionName:'Enable Service',actionIcon:'fa-solid fa-play',action:'enable'},
            {actionName:'Disable Service',actionIcon:'fa-solid fa-ban',action:'disable'},
            {actionName:'Delete',actionIcon:'fa fa-trash'},]" (actionClick)="handleActionClick($event)"
          enableBadge="serviceId">

        </app-color-table>

        <app-pagination [EnableNavigation]="true" [rowData]="serviceList"
          (pageSizeChanged)="handlePageSizeChange($event)">
        </app-pagination>
      </div>

      <div *ngSwitchCase="'Grid'" class="row">

        <div class="col-12 col-sm-6 col-lg-3 custom-col mb-4" *ngFor="let service of serviceList; index as i">
          <div class="project-template-card p-2" [ngClass]="{
                                                              'email-border': service.alertType?.toLowerCase() === 'email',
                                                              'whatsapp-border': service.alertType?.toLowerCase() === 'whatsapp',
                                                              'sms-border': service.alertType?.toLowerCase() === 'sms',
                                                              'disabled-card': service.statusText !== 'Active'
                                                            }">

            <!-- 🔹 Header: Updated Info (Left) & Dropdown (Right) -->
            <div class="d-flex justify-content-between align-items-center mb-1">
              <!-- Updated By & Date -->
              <div class="small temp-bagde">
                <i class="bi bi-fast-forward-fill me-1"></i>Next Run ON :
                {{service.nextExecutionTime|date:'ddMMM,yyyy'}}
              </div>

              <div class="small temp-bagde">
                <i class="bi bi-circle-fill me-1"
                  [ngClass]="service.statusText === 'Active' ? 'text-success' : 'text-danger'"></i>{{service.statusText}}
              </div>

              <ng-container *ngIf="service.alertType">
                <ng-container *ngIf="service.alertType.trim().toLowerCase() === 'email'">
                  <i class="bi bi-envelope-at-fill" style="font-size: 1.5rem; color: #4251c8;"></i>
                </ng-container>
                <ng-container *ngIf="service.alertType.trim().toLowerCase() === 'whatsapp'">
                  <i class="bi bi-whatsapp" style="font-size: 1.5rem; color: #25d366;"></i>

                </ng-container>
                <ng-container *ngIf="service.alertType.trim().toLowerCase() === 'sms'">
                  <i class="bi bi-chat-dots-fill" style="font-size: 1.5rem; color: #fbbc05;"></i>
                </ng-container>
              </ng-container>
              <!-- Dropdown -->
              <div class="dropdown">
                <i class="bi bi-three-dots-vertical menu-icon" data-bs-toggle="dropdown" aria-expanded="false"></i>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li>
                    <a class="dropdown-item d-flex align-items-center gap-2"
                      (click)="handleActionClick({actionName:'Edit',rowData : service})">
                      <i class="bi bi-pencil-square"></i> Edit
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item d-flex align-items-center gap-2"
                      (click)="handleActionClick({actionName:'Add Variable', rowData: service})">
                      <i class="bi bi-plus-square"></i> Add Variable
                    </a>
                  </li>

                  <li>
                    <a class="dropdown-item d-flex align-items-center gap-2"
                      (click)="handleActionClick({actionName: service.statusText === 'Active' ? 'Disable Service' : 'Enable Service', rowData: service})">
                      <i class="bi"
                        [ngClass]="service.statusText === 'Active' ? 'bi-slash-circle' : 'bi-play-circle'"></i>
                      {{ service.statusText === 'Active' ? 'Disable Service' : 'Enable Service' }}
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item d-flex align-items-center gap-2" [routerLink]="[service.serviceId]">
                      <i class="bi bi-eye"></i> view
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item text-danger d-flex align-items-center gap-2"
                      (click)="handleActionClick({actionName:'Delete',rowData : service})">
                      <i class="bi bi-trash"></i> Delete
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <!-- 🔹 Title -->
            <a [routerLink]="[service.serviceId]" class="pr-title fw-semibold mb-1 text-start">{{ service.title}}</a>

            <!-- 🔹 Description -->
            <p class="description text-start"> <strong>Subject : </strong> {{ service.aSubject }}</p>
            <!-- <p class="description text-start"><strong>Type : </strong>{{ service.alertType }}</p> -->

            <!-- 🔹 Avatar & Project Owner -->
            <div class="d-flex justify-content-between align-items-center small border-top pt-1 mt-auto">
              <div class="d-flex align-items-center gap-2">
                <!-- <div class="avatar">{{ service.lastExecutedOn}}</div> -->
                <span class="pr-owner">Last Run On :
                  <ng-container *ngIf="service.lastExecutedOn; else noDate">
                    {{ service.lastExecutedOn | date }}
                  </ng-container>
                  <ng-template #noDate>
                    --/--
                  </ng-template>

                </span>
              </div>
              <div class="d-flex align-items-center gap-2">
                <span>Created On : {{ service.createdOn | date:'dd MMM, yyyy' }}</span>
              </div>
            </div>

          </div>
        </div>


        <div *ngIf="isLoading">
          <div class="row">
            <div class="col-md-6 col-lg-3 custom-col-lg-4 mb-4" *ngFor="let item of [1,2,3,4]">
              <div class="project-template-card p-2">
                <ngx-skeleton-loader count="1" appearance="circle"
                  [theme]="{ width: '40px', height: '40px' }"></ngx-skeleton-loader>
                <ngx-skeleton-loader count="1" [theme]="{ height: '20px', width: '80%' }"></ngx-skeleton-loader>
                <ngx-skeleton-loader count="3"
                  [theme]="{ height: '12px', width: '100%', 'margin-top': '5px' }"></ngx-skeleton-loader>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!isLoading && serviceList.length === 0"
          class="d-flex flex-column align-items-center justify-content-center py-5 w-100">
          <img src="assets/images/no-data-found.svg" alt="No Data Found" style="width: 200px; opacity: 0.85;">
          <p class="text-muted mt-3 mb-0 fw-semibold" style="font-size: 1rem;">No Services Found</p>
          <p class="text-muted small">No alert services are configured yet. Click "Add Services" to create one.</p>
        </div>

      </div>
    </ng-container>
  </div>
</div>












<ng-template #serviceMasterModalContent>

  <!-- Modal Header with Step Indicator -->
  <div class="modal-header border-bottom-0 pb-0 flex-column align-items-start">
    <div class="d-flex justify-content-between align-items-center w-100 mb-3">
      <div>
        <h5 class="modal-title mb-0">
          {{ alertServiceForm.value.serviceId ? 'Edit Service' : 'New Service' }}
        </h5>
        <small class="text-muted">Step {{ currentStep }} of {{ wizardSteps.length }} — {{ wizardSteps[currentStep - 1] }}</small>
      </div>
      <button type="button" class="btn-close" (click)="addServiceModal.close()"></button>
    </div>

    <!-- Step Indicator -->
    <div class="wizard-steps w-100">
      <div *ngFor="let step of wizardSteps; let i = index"
           class="wizard-step"
           [class.active]="currentStep === i + 1"
           [class.completed]="currentStep > i + 1"
           (click)="currentStep > i + 1 ? (currentStep = i + 1) : null"
           [style.cursor]="currentStep > i + 1 ? 'pointer' : 'default'">
        <div class="step-circle">
          <i class="bi bi-check-lg" *ngIf="currentStep > i + 1; else numTpl"></i>
          <ng-template #numTpl>{{ i + 1 }}</ng-template>
        </div>
        <span class="step-label">{{ step }}</span>
        <div class="step-connector" *ngIf="i < wizardSteps.length - 1"
             [class.filled]="currentStep > i + 1"></div>
      </div>
    </div>
  </div>

  <div class="modal-body pt-3">
    <form [formGroup]="alertServiceForm">

      <!-- ── STEP 1: Basic Info ──────────────────────────────────── -->
      <div *ngIf="currentStep === 1" class="step-content">

        <div class="row">
          <div class="col-md-4 mb-3">
            <label class="form-label fw-semibold">Title <span class="text-danger">*</span></label>
            <input type="text" class="form-control form-control-sm" formControlName="title"
                   placeholder="e.g. Support Ticket Created Alert" />
            <app-form-errors [control]="alertServiceForm.controls.title" fieldName="Title"></app-form-errors>
          </div>
          <div class="col-md-8 mb-3">
            <label class="form-label fw-semibold">Description <span class="text-danger">*</span></label>
            <input type="text" class="form-control form-control-sm" formControlName="sDesc"
                   placeholder="What does this service do?" />
            <app-form-errors [control]="alertServiceForm.controls.sDesc" fieldName="Description"></app-form-errors>
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label fw-semibold">Channel <span class="text-danger">*</span></label>
          <div class="d-flex flex-wrap gap-3">
            <label class="alert-type-option" *ngFor="let t of alertTypes">
              <input type="radio" name="alertType" [value]="t.value" formControlName="alertType">
              <i class="{{ t.icon }}"></i>
              <span>{{ t.label }}</span>
            </label>
          </div>
          <app-form-errors [control]="alertServiceForm.controls.alertType" fieldName="Channel"></app-form-errors>
        </div>

      </div>

      <!-- ── STEP 2: Channel Config ──────────────────────────────── -->
      <div *ngIf="currentStep === 2" class="step-content">

        <!-- EMAIL -->
        <div *ngIf="alertServiceForm.get('alertType')?.value === 'Email'">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label fw-semibold">From <span class="text-danger">*</span></label>
              <select class="form-select form-select-sm" formControlName="alertConfigId">
                <option [value]="0" disabled>-- Select Email Config --</option>
                <option *ngFor="let e of emailFromList" [value]="e.emailConfigId">
                  {{ e.iName }} &lt;{{ e.iFrom }}&gt;
                </option>
              </select>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label fw-semibold">To <span class="text-danger">*</span></label>
              <input type="text" class="form-control form-control-sm" formControlName="emailTo"
                     placeholder="recipient@example.com or {{'{{'}}Variable{{'}}'}}">
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">CC</label>
              <input type="text" class="form-control form-control-sm" formControlName="ccTo" placeholder="cc@example.com">
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">BCC</label>
              <input type="text" class="form-control form-control-sm" formControlName="bccTo" placeholder="bcc@example.com">
            </div>
            <div class="col-12 mb-3">
              <label class="form-label fw-semibold">Subject</label>
              <input type="text" class="form-control form-control-sm" formControlName="aSubject"
                     placeholder="Subject line — supports {{'{{'}}Variable{{'}}'}}">
            </div>
            <div class="col-12 mb-3">
              <label class="form-label fw-semibold">Body <span class="text-danger">*</span></label>
              <app-rich-text-editor [control]="alertServiceForm.controls.aBody"></app-rich-text-editor>
            </div>
          </div>
        </div>

        <!-- WHATSAPP -->
        <div *ngIf="alertServiceForm.get('alertType')?.value === 'WhatsApp'">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label fw-semibold">WhatsApp Config <span class="text-danger">*</span></label>
              <select class="form-select form-select-sm" formControlName="alertConfigId">
                <option [value]="0" disabled>-- Select WhatsApp Config --</option>
                <option *ngFor="let w of whatsappConfigList" [value]="w.waConfigId">{{ w.iName }}</option>
              </select>
              <small class="text-muted" *ngIf="alertServiceForm.get('alertConfigId')?.value">
                {{ getWhatsAppConfigData(alertServiceForm.get('alertConfigId')?.value ?? null)?.iDesc }}
              </small>
            </div>
            <div class="col-md-6 mb-3 d-flex flex-column justify-content-center">
              <div class="alert alert-info py-2 px-3 mb-0 small">
                <i class="bi bi-info-circle me-1"></i>
                The recipient number comes from your Data Source query (return it as <code>NTo</code>).
              </div>
            </div>
            <div class="col-12 mb-3">
              <label class="form-label fw-semibold">Message Body <span class="text-danger">*</span></label>
              <app-rich-text-editor [control]="alertServiceForm.controls.aBody"></app-rich-text-editor>
            </div>
          </div>
        </div>

        <!-- SMS -->
        <div *ngIf="alertServiceForm.get('alertType')?.value === 'SMS'">
          <div class="col-12 mb-3">
            <label class="form-label fw-semibold">Message Body</label>
            <textarea class="form-control" formControlName="aBody" rows="5"
                      placeholder="SMS message — supports {{'{{'}}Variable{{'}}'}}"></textarea>
          </div>
        </div>

        <!-- PowerShell / Others / MSTeams — no channel config -->
        <div *ngIf="!channelConfigRequired" class="text-center py-5 text-muted">
          <i class="bi bi-gear-wide-connected fs-1 d-block mb-2"></i>
          <p class="mb-0">No channel-specific configuration required for <strong>{{ alertServiceForm.get('alertType')?.value }}</strong>.</p>
          <p class="small">Continue to configure the data source.</p>
        </div>

      </div>

      <!-- ── STEP 3: Data Source ─────────────────────────────────── -->
      <div *ngIf="currentStep === 3" class="step-content">

        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="form-label fw-semibold">Database Connection <span class="text-danger">*</span></label>
            <select class="form-select form-select-sm" formControlName="dbConnid">
              <option [value]="0" disabled>-- Select Database Connection --</option>
              <option *ngFor="let conn of dbConnectionList" [value]="conn.dbConnId">{{ conn.dbName }}</option>
            </select>
            <app-form-errors [control]="alertServiceForm.controls.dbConnid" fieldName="Database Connection"></app-form-errors>
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label fw-semibold">Data Source Type <span class="text-danger">*</span></label>
            <app-valuelist-selector [control]="alertServiceForm.controls.dataSourceType"
              [vlCode]="'ANNDST'" [placeholder]="'-- Select Data Source Type --'">
            </app-valuelist-selector>
            <app-form-errors [control]="alertServiceForm.controls.dataSourceType" fieldName="Data Source Type"></app-form-errors>
          </div>

          <div class="col-12 mb-1">
            <label class="form-label fw-semibold">Data Source Definition</label>
            <div class="text-muted small mb-1">
              SQL query returning notification rows. Column aliases the worker expects:
              <code>NTo</code>, <code>NSubject</code>, <code>NContent</code>,
              <code>MasterIdCol</code>, <code>MasterTypeCol</code>, <code>ActionTypeCol</code>.
            </div>
            <textarea class="form-control form-control-sm font-monospace" formControlName="dataSourceDef"
                      rows="10" style="resize: vertical;"
                      placeholder="SELECT t.TicketId AS MasterIdCol, 'Module' AS MasterTypeCol, 'Event' AS ActionTypeCol, ...&#10;FROM ...&#10;WHERE NOT EXISTS (...)"></textarea>
          </div>
        </div>

      </div>

      <!-- ── STEP 4: Advanced ───────────────────────────────────── -->
      <div *ngIf="currentStep === 4" class="step-content">

        <!-- Post Service card -->
        <div class="option-card mb-3" [class.option-card--active]="alertServiceForm.get('showPostForm')?.value">
          <div class="option-card-header">
            <div class="d-flex align-items-center gap-2">
              <i class="fa-solid fa-gears text-primary fs-5"></i>
              <div>
                <div class="fw-semibold">Post Service</div>
                <small class="text-muted">Run a query after each notification is sent</small>
              </div>
            </div>
            <div class="form-check form-switch mb-0">
              <input class="form-check-input" type="checkbox" role="switch" formControlName="showPostForm">
            </div>
          </div>
          <div class="option-card-body" *ngIf="alertServiceForm.get('showPostForm')?.value">
            <div class="row">
              <div class="col-md-5 mb-3">
                <label class="form-label">Post Send Data Source Type</label>
                <app-valuelist-selector [control]="alertServiceForm.controls.postSendDataSourceType"
                  [vlCode]="'ANNPSDST'" [placeholder]="'-- Select Type --'">
                </app-valuelist-selector>
              </div>
              <div class="col-12">
                <label class="form-label">Post Send Data Source Definition</label>
                <textarea class="form-control form-control-sm font-monospace" formControlName="postSendDataSourceDef"
                          rows="5" placeholder="UPDATE ... SET NStatus = 'Sent' WHERE Id = {{'{{'}}MasterId{{'}}'}}"></textarea>
              </div>
            </div>
          </div>
        </div>

        <!-- Has Attachment card -->
        <div class="option-card"
             *ngIf="!['WhatsApp','SMS','PowerShellScript','Others'].includes(alertServiceForm.get('alertType')?.value || '')"
             [class.option-card--active]="alertServiceForm.get('hasAttachment')?.value">
          <div class="option-card-header">
            <div class="d-flex align-items-center gap-2">
              <i class="bi bi-paperclip text-primary fs-5"></i>
              <div>
                <div class="fw-semibold">Attachment</div>
                <small class="text-muted">Attach a generated file to the notification</small>
              </div>
            </div>
            <div class="form-check form-switch mb-0">
              <input class="form-check-input" type="checkbox" role="switch" formControlName="hasAttachment">
            </div>
          </div>
          <div class="option-card-body" *ngIf="alertServiceForm.get('hasAttachment')?.value">
            <div class="row">
              <div class="col-md-4 mb-3">
                <label class="form-label">Attachment Type</label>
                <app-valuelist-selector [control]="alertServiceForm.controls.attachmentType"
                  [vlCode]="'ANNAT'" [placeholder]="'-- Select Type --'">
                </app-valuelist-selector>
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">Attachment Path</label>
                <input class="form-control form-control-sm" type="text" formControlName="attachmentPath"
                       placeholder="Path to attachment">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">File Type</label>
                <app-valuelist-selector [control]="alertServiceForm.controls.attachmentFileType"
                  [vlCode]="'ANNAFT'" [placeholder]="'-- Select File Type --'">
                </app-valuelist-selector>
              </div>
              <div class="col-md-6">
                <label class="form-label">Output File Name</label>
                <input type="text" class="form-control form-control-sm" formControlName="outputFileName"
                       placeholder="report_{{'{{'}}Date{{'}}'}}.pdf">
              </div>
            </div>
          </div>
        </div>

      </div>

    </form>
  </div>

  <!-- Footer: navigation + submit -->
  <div class="modal-footer">
    <button class="btn btn-sm btn-outline-secondary" (click)="addServiceModal.close()">Cancel</button>
    <div class="d-flex gap-2 ms-auto">
      <button class="btn btn-sm btn-secondary" (click)="prevStep()" *ngIf="currentStep > 1">
        <i class="bi bi-chevron-left me-1"></i>Back
      </button>
      <button class="btn btn-sm btn-primary" (click)="nextStep()" *ngIf="currentStep < wizardSteps.length">
        Next<i class="bi bi-chevron-right ms-1"></i>
      </button>
      <button class="btn btn-sm btn-success" (click)="submitAlertServiceForm()"
              *ngIf="currentStep === wizardSteps.length"
              [disabled]="isAlertSubmitFormSubmitted">
        <ng-container *ngIf="!isAlertSubmitFormSubmitted; else loadingButton">
          <i class="bi bi-check-lg me-1"></i>Submit
        </ng-container>
        <ng-template #loadingButton>
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Submitting...
        </ng-template>
      </button>
    </div>
  </div>

</ng-template>



<ng-template #serviceVariableModalContent>
  <div class="modal-header">
    <h5 class="modal-title">New Service Variable</h5>
    <button type="button" class="btn-close" (click)="addServiceVariableModal.close()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="serviceVariableForm">
      <div class="row">
        <div class="col-md-12 mb-2">
          <div class="form-group">
            <label for="varInstance">Variable Instance <span style="color: red;">*</span></label>
            <input type="text" class="form-control mt-1" [formControl]="serviceVariableForm.controls.varInstance"
              placeholder="Instance Name">
          </div>
        </div>

        <div class="col-md-12 mb-2">
          <div class="form-group">
            <label for="varValue">Variable Value <span style="color: red;">*</span></label>
            <input type="text" class="form-control mt-1" [formControl]="serviceVariableForm.controls.varValue"
              placeholder="Value">
          </div>
        </div>

        <div class="col-md-12 mb-2">
          <div class="form-group">
            <label for="varType">Variable Type <span style="color: red;">*</span></label>
            <select class="form-select" id="varType" [formControl]="serviceVariableForm.controls.varType">
              <option [ngValue]="null" disabled>-- Select Type --</option>
              <option *ngFor="let type of varTypeOptions" [ngValue]="type">{{ type }}</option>
            </select>
          </div>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="submitServiceVaribaleForm()"
      [disabled]="isServiceVariableFormSubmitted">
      <ng-container *ngIf="!isServiceVariableFormSubmitted; else loadingButton">Submit</ng-container>
      <ng-template #loadingButton>
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Submitting...
      </ng-template>
    </button>
    <button type="button" class="btn btn-secondary" (click)="addServiceVariableModal.close()">Close</button>
  </div>
</ng-template>